import { GulliverImagePreviewModule } from '@aipb/gulliver/image-preview';
import { UiOpenLayersModule } from '@aipb/shared/ui/open-layers';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ImageStripComponent } from './image-strip/image-strip.component';
import { OpenLayersComponent } from './open-layers/open-layers.component';
import { RecordOpenLayersComponent } from './record-open-layers/record-open-layers.component';

@NgModule({
  declarations: [RecordOpenLayersComponent, ImageStripComponent, OpenLayersComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatButtonModule,
    MatTabsModule,
    MatChipsModule,
    ScrollingModule,
    UiOpenLayersModule,
    GulliverImagePreviewModule
  ],
  exports: [RecordOpenLayersComponent]
})
export class RecordOpenLayersModule {}
